import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
  },
  image: {
    height: '100%',
    objectFit: 'contain',
    width: '100%',
  },
});
